import { onBrand } from '@foodamigos/ui';

const DESIGN_SYSTEM_BRAND_VARIABLES = ['--fa-brand', '--fa-color-on-brand'];

/** The design system's FoodAmigos green, not the dashboard's older theme green (#69CE8C). */
export const DESIGN_SYSTEM_FOOD_AMIGOS_GREEN = '#6acc8f';

const BRAND_COLOR_VARIABLES = [
  '--primary-color',
  '--primary-color-rgb',
  '--primary-gradient-rgb-color-1',
  '--primary-gradient-rgb-color-2',
];

export function hexToRgbChannels(hex) {
  const value = hex?.replace('#', '');

  if (!value || value.length !== 6) {
    return null;
  }

  return [0, 2, 4].map((offset) => parseInt(value.slice(offset, offset + 2), 16)).join(' ');
}

export function applyBrandColor(primaryColor) {
  const channels = hexToRgbChannels(primaryColor);

  if (!channels) {
    return;
  }

  const style = document.documentElement.style;
  style.setProperty('--primary-color', primaryColor);
  style.setProperty('--primary-color-rgb', channels);
  style.setProperty('--primary-gradient-rgb-color-1', channels);
  style.setProperty('--primary-gradient-rgb-color-2', channels);
}

/**
 * The brand of @foodamigos/ui components. Set on <html>: the package derives `--fa-color-brand` and its
 * shades from `--fa-brand` on `:root`, so setting it lower in the tree (e.g. on a dialog) has no effect.
 * Without a usable colour (a neutral brand) the package keeps its monochrome default.
 */
export function applyDesignSystemBrand(color) {
  const style = document.documentElement.style;

  if (!hexToRgbChannels(color)) {
    DESIGN_SYSTEM_BRAND_VARIABLES.forEach((variable) => style.removeProperty(variable));

    return;
  }

  style.setProperty('--fa-brand', color);
  style.setProperty('--fa-color-on-brand', onBrand(color));
}

// Restores the FoodAmigos defaults from global.css by dropping the inline overrides.
export function clearBrandColor() {
  BRAND_COLOR_VARIABLES.forEach((variable) => document.documentElement.style.removeProperty(variable));
}
